var globalScope = typeof window !== "undefined" ? window : typeof process === 'object' && typeof require === 'function' && typeof global === 'object' ? global : this;

/**
 * The interface for callbacks resolving `window.Takt`.
 *
 * @callback taktCallback Function to invoke once `window.Takt` is available.
 * @param {object} takt A reference to `window.Takt`
 */

/**
 * The `whenTakt` function is a mechanism to ensure `window.Takt` is available before
 * executing code.  When `window.Takt` becomes available on the page, `whenTakt` invokes
 * the provided callback with `window.Takt` passed as the first parameter.
 *
 * @param {taktCallback} callback Function to invoke once `window.Takt` is available.
 */
export function whenTakt(callback) {
  if (globalScope.Takt) {
    callback(globalScope.Takt);
    return;
  }
  if (globalScope.AmazonUIPageJS) {
    globalScope.AmazonUIPageJS.when('takt').execute(callback);
  } else if (globalScope.__taktLoadedCallbacks) {
    globalScope.__taktLoadedCallbacks.push(callback);
  }
}

/**
 * The interface for callbacks resolving window.AmazonTakt.
 *
 * @callback amazonTaktCallback Function to invoke once window.AmazonTakt is available.
 * @param {object} amazonTakt A reference to window.AmazonTakt
 */

/**
 * The `whenAmazonTakt` function is a mechanism to ensure `window.AmazonTakt` is
 * available before executing code.  When `window.AmazonTakt` becomes available on
 * the page, `whenAmazonTakt` invokes the provided callback with `window.AmazonTakt`
 * passed as the first parameter.
 *
 * @param {amazonTaktCallback} callback Function to invoke once `window.AmazonTakt` is available.
 */
export function whenAmazonTakt(callback) {
  if (globalScope.AmazonTakt) {
    callback(globalScope.AmazonTakt);
    return;
  }
  if (globalScope.AmazonUIPageJS) {
    globalScope.AmazonUIPageJS.when('amazon-takt').execute(callback);
  } else if (globalScope.__taktLoadedCallbacks) {
    globalScope.__taktLoadedCallbacks.push(function () {
      callback(globalScope.AmazonTakt);
    });
  }
}
//# sourceMappingURL=index.js.map